import * as e from "@apollo/client";
import { ApolloClient as t, InMemoryCache as n, createHttpLink as r, from as i, gql as a } from "@apollo/client";
import { Modal as o } from "@dixa/lib-shared-habla";
import { createPersistedQueryLink as s } from "@apollo/client/link/persisted-queries";
import { setContext as c } from "@apollo/client/link/context";
import { authManager as l, parseAccessToken as u } from "lib-shared-auth";
import { config as d } from "lib-shared-backend-config";
import { jsx as f, jsxs as p } from "react/jsx-runtime";
import * as m from "react";
import h, { Suspense as g, createContext as _, useCallback as v, useContext as y, useEffect as b, useMemo as ee, useRef as te, useState as ne } from "react";
import re from "classnames";
//#region \0rolldown/runtime.js
var ie = Object.create, ae = Object.defineProperty, oe = Object.getOwnPropertyDescriptor, se = Object.getOwnPropertyNames, ce = Object.getPrototypeOf, le = Object.prototype.hasOwnProperty, x = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), ue = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = se(t), a = 0, o = i.length, s; a < o; a++) s = i[a], !le.call(e, s) && s !== n && ae(e, s, {
		get: ((e) => t[e]).bind(null, s),
		enumerable: !(r = oe(t, s)) || r.enumerable
	});
	return e;
}, de = (e, t, n) => (n = e == null ? {} : ie(ce(e)), ue(t || !e || !e.__esModule ? ae(n, "default", {
	value: e,
	enumerable: !0
}) : n, e)), fe = (e) => {
	let t = new DataView(e), n = "";
	for (let e = 0; e < t.byteLength; e += 4) n += t.getUint32(e).toString(16).padStart(8, "0");
	return n;
}, pe = ((e) => async (t, { outputFormat: n = "hex" } = {}) => {
	typeof t == "string" && (t = new globalThis.TextEncoder().encode(t));
	let r = await globalThis.crypto.subtle.digest(e, t);
	return n === "hex" ? fe(r) : r;
})("SHA-256"), me = "authData";
async function he() {
	await l.getAuthData();
	let e = localStorage.getItem(me);
	return e ? JSON.parse(e) : null;
}
function ge() {
	let e = localStorage.getItem(me);
	if (!e) return null;
	try {
		let { access_token: t } = JSON.parse(e);
		return u(t).user_id;
	} catch {
		return null;
	}
}
async function _e() {
	return `Bearer ${(await he())?.access_token}`;
}
//#endregion
//#region ../utils/src/apollo.ts
function ve() {
	return c(async (e, { headers: t }) => {
		let n = await _e();
		return { headers: {
			...t,
			authorization: n
		} };
	});
}
//#endregion
//#region ../delivery-common/src/graphql.ts
var S = {}, ye = /* @__PURE__ */ function(e) {
	return e.Negative = "NEGATIVE", e.Positive = "POSITIVE", e;
}({}), be = /* @__PURE__ */ function(e) {
	return e.Queue = "QUEUE", e;
}({}), xe = /* @__PURE__ */ function(e) {
	return e.Ar = "ar", e.Bg = "bg", e.Ca = "ca", e.CaValencia = "ca_valencia", e.Cs = "cs", e.Da = "da", e.De = "de", e.DeAt = "de_at", e.DeBe = "de_be", e.DeCh = "de_ch", e.Ee = "ee", e.El = "el", e.En = "en", e.EnAu = "en_au", e.EnCa = "en_ca", e.EnGb = "en_gb", e.EnIe = "en_ie", e.EnNz = "en_nz", e.EnUs = "en_us", e.Es = "es", e.Es_419 = "es_419", e.Et = "et", e.Eu = "eu", e.Fa = "fa", e.Fi = "fi", e.Fr = "fr", e.FrBe = "fr_be", e.FrCa = "fr_ca", e.FrCh = "fr_ch", e.Gl = "gl", e.Hi = "hi", e.Hr = "hr", e.Hu = "hu", e.Id = "id", e.Is = "is", e.It = "it", e.ItCh = "it_ch", e.Iw = "iw", e.Ja = "ja", e.Ko = "ko", e.Lt = "lt", e.Lv = "lv", e.Nb = "nb", e.Nl = "nl", e.NlBe = "nl_be", e.Nn = "nn", e.No = "no", e.Pl = "pl", e.Pt = "pt", e.PtBr = "pt_br", e.Ro = "ro", e.Ru = "ru", e.Sk = "sk", e.Sl = "sl", e.Sq = "sq", e.Sr = "sr", e.Sv = "sv", e.Th = "th", e.Tr = "tr", e.Uk = "uk", e.Vi = "vi", e.Zh = "zh", e.ZhHant = "zh_hant", e;
}({}), Se = /* @__PURE__ */ function(e) {
	return e.ConversationText = "CONVERSATION_TEXT", e.Tags = "TAGS", e;
}({}), C = a`
  fragment ArticleAvailability on AvailableAtPayload {
    helpCenters {
      name
      url
    }
    internalKbs {
      name
      collectionId
      iconColor
    }
  }
`, Ce = a`
  fragment ArticleSearchResult on PublishedArticle {
    id
    title
    parentCategory {
      id
      title
    }
    tags {
      id
      name
    }
    collectionId
    availableAt {
      ...ArticleAvailability
    }
  }
  ${C}
`, we = a`
  fragment InternalKbFields on Collection {
    id
    title
    internalKbEnabled
    linkedResources {
      id
      type
      name
    }
  }
`, Te = a`
  fragment InternalKbCategoryFields on KbCategory {
    id
    title
    parentCategory {
      id
    }
  }
`, Ee = a`
  fragment InternalKbArticleAvailability on KbArticle {
    availableAt {
      ...ArticleAvailability
    }
  }
  ${C}
`, w = a`
  fragment InternalKbArticleFields on KbArticle {
    id
    title
    publishedAt
    parentCategory {
      id
    }
  }
`, De = a`
  fragment InternalKbArticleContent on KbArticle {
    parentCategory {
      id
      title
    }
    content {
      html
      cssVersion
    }
    publishedBy {
      name
    }
    tags {
      id
      name
      color
      type
      isDeactivated
    }
  }
`, Oe = a`
  fragment DeliveryOrganizationSettings on OrganisationSettingsPayload {
    defaultLanguage {
      ...LanguageFields
    }
    enabledLanguages {
      ...LanguageFields
    }
  }
  ${a`
  fragment LanguageFields on Language {
    languageId
    description
    nativeDescription
  }
`}
`, ke = a`
  query Article($id: ID!, $languageId: LanguageId!, $collectionId: ID!) {
    suggestions {
      article(id: $id, languageId: $languageId, collectionId: $collectionId) {
        id
        tags {
          id
          name
          type
          isDeactivated
        }
        title
        content {
          html
          cssVersion
        }
        updatedAt
        languageId
        parentCategory {
          title
          id
        }
        collectionId
        availableAt {
          ...ArticleAvailability
        }
      }
    }
  }
  ${C}
`, Ae = a`
  query ArticleSearchTerms(
    $languageId: LanguageId!
    $limit: Limit!
    $searchTerms: NonEmptyString!
    $collectionIds: [ID!]!
    $tagIds: [ID!]
  ) {
    suggestions {
      articleSearch(
        languageId: $languageId
        limit: $limit
        collectionIds: $collectionIds
      ) {
        byTerms(searchTerms: $searchTerms, tagIds: $tagIds) {
          results {
            ...ArticleSearchResult
          }
        }
      }
    }
  }
  ${Ce}
`;
function je(t) {
	let n = {
		...S,
		...t
	};
	return e.useQuery(Ae, n);
}
var Me = a`
  query Collections {
    collections {
      results {
        id
        title
        linkedResources {
          id
        }
      }
    }
  }
`;
function Ne(t) {
	let n = {
		...S,
		...t
	};
	return e.useQuery(Me, n);
}
var Pe = a`
  query ConversationSuggestions(
    $languageId: LanguageId!
    $csid: Long!
    $limit: Limit!
  ) {
    suggestions {
      conversation(csid: $csid, languageId: $languageId) {
        articles(limit: $limit) {
          results {
            ...ArticleSearchResult
          }
          searchMethodsUsed
        }
      }
    }
  }
  ${Ce}
`;
function Fe(t) {
	let n = {
		...S,
		...t
	};
	return e.useQuery(Pe, n);
}
var Ie = a`
  query ExternalResource($id: ID!, $type: ExternalResourceType!) {
    externalResource(id: $id, type: $type) {
      linkedCollections {
        id
        title
      }
    }
  }
`;
function Le(t) {
	let n = {
		...S,
		...t
	};
	return e.useQuery(Ie, n);
}
a`
  query InternalKbArticle(
    $collectionId: ID!
    $articleId: ID!
    $languageId: LanguageId!
  ) {
    knowledgeBaseArticle: knowledgeBase(
      collectionId: $collectionId
      languageId: $languageId
    ) {
      article(id: $articleId) {
        ...InternalKbArticleFields
        ...InternalKbArticleContent
        ...InternalKbArticleAvailability
      }
    }
  }
  ${w}
  ${De}
  ${Ee}
`, a`
  query InternalKbCollection($collectionId: ID!, $languageId: LanguageId!) {
    knowledgeBase(collectionId: $collectionId, languageId: $languageId) {
      collection {
        ...InternalKbFields
      }
      theme {
        colors {
          icon
        }
      }
      description
      categories {
        ...InternalKbCategoryFields
        categories {
          ...InternalKbCategoryFields
          categories {
            ...InternalKbCategoryFields
            categories {
              ...InternalKbCategoryFields
              categories {
                ...InternalKbCategoryFields
                articles {
                  ...InternalKbArticleFields
                }
              }
              articles {
                ...InternalKbArticleFields
              }
            }
            articles {
              ...InternalKbArticleFields
            }
          }
          articles {
            ...InternalKbArticleFields
          }
        }
        articles {
          ...InternalKbArticleFields
        }
      }
    }
  }
  ${we}
  ${Te}
  ${w}
`, a`
  query InternalKbs($languageId: LanguageId) {
    knowledgeBases(languageId: $languageId) {
      results {
        collection {
          id
        }
        title
        description
        theme {
          colors {
            icon
          }
        }
      }
    }
  }
`, a`
  query InternalKbSearch(
    $collectionId: ID!
    $languageId: LanguageId!
    $searchTerms: NonEmptyString!
    $limit: Limit
    $offset: Offset
  ) {
    knowledgeBase(collectionId: $collectionId, languageId: $languageId) {
      articleSearch(searchTerms: $searchTerms, limit: $limit, offset: $offset) {
        results {
          ...InternalKbArticleFields
          searchMatchedOn {
            body
          }
          parentCategory {
            id
            title
          }
        }
      }
    }
  }
  ${w}
`;
var Re = a`
  query OrganizationSettings {
    organisationSettings {
      ...DeliveryOrganizationSettings
    }
  }
  ${Oe}
`;
function ze(t) {
	let n = {
		...S,
		...t
	};
	return e.useQuery(Re, n);
}
var Be = a`
  mutation ArticleRatingTrack(
    $articleId: ID!
    $languageId: LanguageId!
    $rating: ArticleRating!
    $ctx: EventCtxInput!
  ) {
    articleRatingSubmit(
      articleId: $articleId
      languageId: $languageId
      rating: $rating
      ctx: $ctx
    ) {
      eventId
    }
  }
`;
function Ve(t) {
	let n = {
		...S,
		...t
	};
	return e.useMutation(Be, n);
}
var He = a`
  mutation ArticleViewTrack(
    $articleId: ID!
    $languageId: LanguageId!
    $ctx: EventCtxInput!
  ) {
    articleViewTrack(
      articleId: $articleId
      languageId: $languageId
      ctx: $ctx
    ) {
      eventId
    }
  }
`;
function Ue(t) {
	let n = {
		...S,
		...t
	};
	return e.useMutation(He, n);
}
var We = a`
  mutation SearchQueryTrack(
    $searchInput: ArticleSearchInput!
    $searchResults: [ID!]!
    $ctx: EventCtxInput!
  ) {
    searchQueryTrack(
      searchInput: $searchInput
      searchResults: $searchResults
      ctx: $ctx
    ) {
      eventId
    }
  }
`;
function Ge(t) {
	let n = {
		...S,
		...t
	};
	return e.useMutation(We, n);
}
//#endregion
//#region ../modal/src/Context.tsx
var Ke = _({
	hideModal: () => {},
	showModal: () => {}
});
function qe({ children: e }) {
	let [t, n] = ne(null), r = v((e, t) => {
		n({
			modal: e,
			props: t
		});
	}, []), i = v(() => n(null), []), [a, o] = t ? [t.modal, t.props] : [];
	return /* @__PURE__ */ p(Ke.Provider, {
		value: {
			showModal: r,
			hideModal: i
		},
		children: [e, /* @__PURE__ */ f(g, {
			fallback: null,
			children: a && /* @__PURE__ */ f(a, { ...o })
		})]
	});
}
function Je() {
	let { showModal: e, hideModal: t } = y(Ke);
	return {
		showModal: e,
		hideModal: t
	};
}
var Ye = { modalBody: "_modalBody_1eukg_1" };
//#endregion
//#region ../modal/src/ModalWrapper/index.tsx
function Xe({ children: e, className: t, allowEscClose: n = !0 }) {
	let { hideModal: r } = Je();
	return /* @__PURE__ */ f(o, {
		allowEscClose: n,
		className: re(Ye.modalBody, t),
		isOpen: !0,
		onClose: r,
		children: e
	});
}
//#endregion
//#region ../utils/src/contexts/notification.tsx
var Ze = _((e) => {
	console.log("Notification: ", e);
});
Ze.displayName = "NotificationContext";
//#endregion
//#region ../../../node_modules/proxy-compare/dist/index.modern.js
var Qe = Symbol(), T = Symbol(), E = "a", D = "w", $e = (e, t) => new Proxy(e, t), O = Object.getPrototypeOf, k = /* @__PURE__ */ new WeakMap(), et = (e) => e && (k.has(e) ? k.get(e) : O(e) === Object.prototype || O(e) === Array.prototype), A = (e) => typeof e == "object" && !!e, tt = (e) => {
	if (Array.isArray(e)) return Array.from(e);
	let t = Object.getOwnPropertyDescriptors(e);
	return Object.values(t).forEach((e) => {
		e.configurable = !0;
	}), Object.create(O(e), t);
}, j = (e) => e[T] || e, M = (e, t, n, r) => {
	if (!et(e)) return e;
	let i = r && r.get(e);
	if (!i) {
		let t = j(e);
		i = ((e) => Object.values(Object.getOwnPropertyDescriptors(e)).some((e) => !e.configurable && !e.writable))(t) ? [t, tt(t)] : [t], r?.set(e, i);
	}
	let [a, o] = i, s = n && n.get(a);
	return s && s[1].f === !!o || (s = ((e, t) => {
		let n = { f: t }, r = !1, i = (t, i) => {
			if (!r) {
				let r = n[E].get(e);
				if (r || (r = {}, n[E].set(e, r)), t === D) r[D] = !0;
				else {
					let e = r[t];
					e || (e = /* @__PURE__ */ new Set(), r[t] = e), e.add(i);
				}
			}
		}, a = {
			get: (t, r) => r === T ? e : (i("k", r), M(Reflect.get(t, r), n[E], n.c, n.t)),
			has: (t, a) => a === Qe ? (r = !0, n[E].delete(e), !0) : (i("h", a), Reflect.has(t, a)),
			getOwnPropertyDescriptor: (e, t) => (i("o", t), Reflect.getOwnPropertyDescriptor(e, t)),
			ownKeys: (e) => (i(D), Reflect.ownKeys(e))
		};
		return t && (a.set = a.deleteProperty = () => !1), [a, n];
	})(a, !!o), s[1].p = $e(o || a, s[0]), n && n.set(a, s)), s[1][E] = t, s[1].c = n, s[1].t = r, s[1].p;
}, N = (e, t, n, r, i = Object.is) => {
	if (i(e, t)) return !1;
	if (!A(e) || !A(t)) return !0;
	let a = n.get(j(e));
	if (!a) return !0;
	if (r) {
		let n = r.get(e);
		if (n && n.n === t) return n.g;
		r.set(e, {
			n: t,
			g: !1
		});
	}
	let o = null;
	try {
		for (let n of a.h || []) if (o = Reflect.has(e, n) !== Reflect.has(t, n), o) return o;
		if (!0 === a[D]) {
			if (o = ((e, t) => {
				let n = Reflect.ownKeys(e), r = Reflect.ownKeys(t);
				return n.length !== r.length || n.some((e, t) => e !== r[t]);
			})(e, t), o) return o;
		} else for (let n of a.o || []) if (o = !!Reflect.getOwnPropertyDescriptor(e, n) != !!Reflect.getOwnPropertyDescriptor(t, n), o) return o;
		for (let s of a.k || []) if (o = N(e[s], t[s], n, r, i), o) return o;
		return o === null && (o = !0), o;
	} finally {
		r && r.set(e, {
			n: t,
			g: o
		});
	}
}, nt = (e) => et(e) && e[T] || null, rt = (e, t = !0) => {
	k.set(e, t);
}, it = (e, t, n) => {
	let r = [], i = /* @__PURE__ */ new WeakSet(), a = (e, o) => {
		if (i.has(e)) return;
		A(e) && i.add(e);
		let s = A(e) && t.get(j(e));
		if (s) {
			var c, l;
			if ((c = s.h) == null || c.forEach((e) => {
				let t = `:has(${String(e)})`;
				r.push(o ? [...o, t] : [t]);
			}), !0 === s[D]) {
				let e = ":ownKeys";
				r.push(o ? [...o, e] : [e]);
			} else {
				var u;
				(u = s.o) == null || u.forEach((e) => {
					let t = `:hasOwn(${String(e)})`;
					r.push(o ? [...o, t] : [t]);
				});
			}
			(l = s.k) == null || l.forEach((t) => {
				n && !("value" in (Object.getOwnPropertyDescriptor(e, t) || {})) || a(e[t], o ? [...o, t] : [t]);
			});
		} else o && r.push(o);
	};
	return a(e), r;
}, P = (e) => typeof e == "object" && !!e, F = /* @__PURE__ */ new WeakMap(), I = /* @__PURE__ */ new WeakSet(), [at] = ((e = Object.is, t = (e, t) => new Proxy(e, t), n = (e) => P(e) && !I.has(e) && (Array.isArray(e) || !(Symbol.iterator in e)) && !(e instanceof WeakMap) && !(e instanceof WeakSet) && !(e instanceof Error) && !(e instanceof Number) && !(e instanceof Date) && !(e instanceof String) && !(e instanceof RegExp) && !(e instanceof ArrayBuffer), r = (e) => {
	switch (e.status) {
		case "fulfilled": return e.value;
		case "rejected": throw e.reason;
		default: throw e;
	}
}, i = /* @__PURE__ */ new WeakMap(), a = (e, t, n = r) => {
	let o = i.get(e);
	if (o?.[0] === t) return o[1];
	let s = Array.isArray(e) ? [] : Object.create(Object.getPrototypeOf(e));
	return rt(s, !0), i.set(e, [t, s]), Reflect.ownKeys(e).forEach((t) => {
		if (Object.getOwnPropertyDescriptor(s, t)) return;
		let r = Reflect.get(e, t), { enumerable: i } = Reflect.getOwnPropertyDescriptor(e, t), o = {
			value: r,
			enumerable: i,
			configurable: !0
		};
		if (I.has(r)) rt(r, !1);
		else if (r instanceof Promise) delete o.value, o.get = () => n(r);
		else if (F.has(r)) {
			let [e, t] = F.get(r);
			o.value = a(e, t(), n);
		}
		Object.defineProperty(s, t, o);
	}), Object.preventExtensions(s);
}, o = /* @__PURE__ */ new WeakMap(), s = [1, 1], c = (r) => {
	if (!P(r)) throw Error("object required");
	let i = o.get(r);
	if (i) return i;
	let l = s[0], u = /* @__PURE__ */ new Set(), d = (e, t = ++s[0]) => {
		l !== t && (l = t, u.forEach((n) => n(e, t)));
	}, f = s[1], p = (e = ++s[1]) => (f !== e && !u.size && (f = e, h.forEach(([t]) => {
		let n = t[1](e);
		n > l && (l = n);
	})), l), m = (e) => (t, n) => {
		let r = [...t];
		r[1] = [e, ...r[1]], d(r, n);
	}, h = /* @__PURE__ */ new Map(), g = (e, t) => {
		if (u.size) {
			let n = t[3](m(e));
			h.set(e, [t, n]);
		} else h.set(e, [t]);
	}, _ = (e) => {
		var t;
		let n = h.get(e);
		n && (h.delete(e), (t = n[1]) == null || t.call(n));
	}, v = (e) => (u.add(e), u.size === 1 && h.forEach(([e, t], n) => {
		let r = e[3](m(n));
		h.set(n, [e, r]);
	}), () => {
		u.delete(e), u.size === 0 && h.forEach(([e, t], n) => {
			t && (t(), h.set(n, [e]));
		});
	}), y = Array.isArray(r) ? [] : Object.create(Object.getPrototypeOf(r)), b = t(y, {
		deleteProperty(e, t) {
			let n = Reflect.get(e, t);
			_(t);
			let r = Reflect.deleteProperty(e, t);
			return r && d([
				"delete",
				[t],
				n
			]), r;
		},
		set(t, r, i, a) {
			let s = Reflect.has(t, r), l = Reflect.get(t, r, a);
			if (s && (e(l, i) || o.has(i) && e(l, o.get(i)))) return !0;
			_(r), P(i) && (i = nt(i) || i);
			let u = i;
			if (i instanceof Promise) i.then((e) => {
				i.status = "fulfilled", i.value = e, d([
					"resolve",
					[r],
					e
				]);
			}).catch((e) => {
				i.status = "rejected", i.reason = e, d([
					"reject",
					[r],
					e
				]);
			});
			else {
				!F.has(i) && n(i) && (u = c(i));
				let e = !I.has(u) && F.get(u);
				e && g(r, e);
			}
			return Reflect.set(t, r, u, a), d([
				"set",
				[r],
				i,
				l
			]), !0;
		}
	});
	o.set(r, b);
	let ee = [
		y,
		p,
		a,
		v
	];
	return F.set(b, ee), Reflect.ownKeys(r).forEach((e) => {
		let t = Object.getOwnPropertyDescriptor(r, e);
		"value" in t && (b[e] = r[e], delete t.value, delete t.writable), Object.defineProperty(y, e, t);
	}), b;
}) => [
	c,
	F,
	I,
	e,
	t,
	n,
	r,
	i,
	a,
	o,
	s
])();
function L(e = {}) {
	return at(e);
}
function ot(e) {
	return F.get(e)?.[1]();
}
function R(e, t, n) {
	let r = F.get(e), i, a = [], o = r[3], s = !1, c = o((e) => {
		if (a.push(e), n) {
			t(a.splice(0));
			return;
		}
		i ||= Promise.resolve().then(() => {
			i = void 0, s && t(a.splice(0));
		});
	});
	return s = !0, () => {
		s = !1, c();
	};
}
function z(e, t) {
	let [n, r, i] = F.get(e);
	return i(n, r(), t);
}
//#endregion
//#region builtin:esm-external-require-react
var B = /* @__PURE__ */ x(((e, t) => {
	t.exports = { ...m };
})), st = /* @__PURE__ */ x(((e) => {
	var t = B();
	function n(e, t) {
		return e === t && (e !== 0 || 1 / e == 1 / t) || e !== e && t !== t;
	}
	var r = typeof Object.is == "function" ? Object.is : n, i = t.useState, a = t.useEffect, o = t.useLayoutEffect, s = t.useDebugValue;
	function c(e, t) {
		var n = t(), r = i({ inst: {
			value: n,
			getSnapshot: t
		} }), c = r[0].inst, u = r[1];
		return o(function() {
			c.value = n, c.getSnapshot = t, l(c) && u({ inst: c });
		}, [
			e,
			n,
			t
		]), a(function() {
			return l(c) && u({ inst: c }), e(function() {
				l(c) && u({ inst: c });
			});
		}, [e]), s(n), n;
	}
	function l(e) {
		var t = e.getSnapshot;
		e = e.value;
		try {
			var n = t();
			return !r(e, n);
		} catch {
			return !0;
		}
	}
	function u(e, t) {
		return t();
	}
	var d = typeof window > "u" || window.document === void 0 || window.document.createElement === void 0 ? u : c;
	e.useSyncExternalStore = t.useSyncExternalStore === void 0 ? d : t.useSyncExternalStore;
})), ct = /* @__PURE__ */ x(((e) => {
	process.env.NODE_ENV !== "production" && (function() {
		typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(/* @__PURE__ */ Error());
		var t = B(), n = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
		function r(e) {
			i("error", e, [...arguments].slice(1));
		}
		function i(e, t, r) {
			var i = n.ReactDebugCurrentFrame.getStackAddendum();
			i !== "" && (t += "%s", r = r.concat([i]));
			var a = r.map(function(e) {
				return String(e);
			});
			a.unshift("Warning: " + t), Function.prototype.apply.call(console[e], console, a);
		}
		function a(e, t) {
			return e === t && (e !== 0 || 1 / e == 1 / t) || e !== e && t !== t;
		}
		var o = typeof Object.is == "function" ? Object.is : a, s = t.useState, c = t.useEffect, l = t.useLayoutEffect, u = t.useDebugValue, d = !1, f = !1;
		function p(e, n, i) {
			d || t.startTransition !== void 0 && (d = !0, r("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
			var a = n();
			f || o(a, n()) || (r("The result of getSnapshot should be cached to avoid an infinite loop"), f = !0);
			var p = s({ inst: {
				value: a,
				getSnapshot: n
			} }), h = p[0].inst, g = p[1];
			return l(function() {
				h.value = a, h.getSnapshot = n, m(h) && g({ inst: h });
			}, [
				e,
				a,
				n
			]), c(function() {
				return m(h) && g({ inst: h }), e(function() {
					m(h) && g({ inst: h });
				});
			}, [e]), u(a), a;
		}
		function m(e) {
			var t = e.getSnapshot, n = e.value;
			try {
				return !o(n, t());
			} catch {
				return !0;
			}
		}
		function h(e, t, n) {
			return t();
		}
		var g = typeof window < "u" && window.document !== void 0 && window.document.createElement !== void 0 ? p : h;
		e.useSyncExternalStore = t.useSyncExternalStore === void 0 ? g : t.useSyncExternalStore, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(/* @__PURE__ */ Error());
	})();
})), lt = /* @__PURE__ */ de((/* @__PURE__ */ x(((e, t) => {
	process.env.NODE_ENV === "production" ? t.exports = st() : t.exports = ct();
})))(), 1), { use: ut } = h, { useSyncExternalStore: dt } = lt.default, ft = /* @__PURE__ */ new WeakMap();
function pt(e, t) {
	let n = t?.sync, r = te(), i = te(), a = !0, o = dt(v((t) => {
		let r = R(e, t, n);
		return t(), r;
	}, [e, n]), () => {
		let t = z(e, ut);
		try {
			if (!a && r.current && i.current && !N(r.current, t, i.current, /* @__PURE__ */ new WeakMap())) return r.current;
		} catch {}
		return t;
	}, () => z(e, ut));
	a = !1;
	let s = /* @__PURE__ */ new WeakMap();
	return b(() => {
		r.current = o, i.current = s;
	}), M(o, s, ee(() => /* @__PURE__ */ new WeakMap(), []), ft);
}
//#endregion
//#region ../../../node_modules/derive-valtio/dist/index.modern.js
var V = /* @__PURE__ */ new WeakMap(), H = /* @__PURE__ */ new WeakMap(), mt = (e, t) => {
	let n = V.get(e);
	n && (n[0].forEach((t) => {
		let { d: n } = t;
		e !== n && mt(n);
	}), ++n[2], t && n[3].add(t));
}, U = (e) => {
	let t = V.get(e);
	t && (--t[2], t[2] || (t[3].forEach((e) => e()), t[3].clear()), t[0].forEach((t) => {
		let { d: n } = t;
		e !== n && U(n);
	}));
}, ht = (e) => {
	let { s: t, d: n } = e, r = H.get(n);
	r || (r = [/* @__PURE__ */ new Set()], H.set(e.d, r)), r[0].add(e);
	let i = V.get(t);
	if (!i) {
		let e = /* @__PURE__ */ new Set();
		i = [
			e,
			R(t, (n) => {
				e.forEach((e) => {
					let { d: r, c: i, n: a, i: o } = e;
					t === r && n.every((e) => e[1].length === 1 && o.includes(e[1][0])) || e.p || (mt(t, i), a ? U(t) : e.p = Promise.resolve().then(() => {
						delete e.p, U(t);
					}));
				});
			}, !0),
			0,
			/* @__PURE__ */ new Set()
		], V.set(t, i);
	}
	i[0].add(e);
}, gt = (e) => {
	let { s: t, d: n } = e, r = H.get(n);
	r?.[0].delete(e), r?.[0].size === 0 && H.delete(n);
	let i = V.get(t);
	if (i) {
		let [n, r] = i;
		n.delete(e), n.size || (r(), V.delete(t));
	}
};
function _t(e, t) {
	let n = t?.proxy || L({}), r = !(t == null || !t.sync), i = Object.keys(e);
	return i.forEach((t) => {
		if (Object.getOwnPropertyDescriptor(n, t)) throw Error("object property already defined");
		let a = e[t], o = null, s = () => {
			if (o && (Array.from(o).map(([e]) => ((e, t) => {
				let n = V.get(e);
				return !(n == null || !n[2] || (n[3].add(t), 0));
			})(e, s)).some((e) => e) || Array.from(o).every(([e, t]) => ot(e) === t.v))) return;
			let e = /* @__PURE__ */ new Map(), c = a((t) => (e.set(t, { v: ot(t) }), t)), l = () => {
				var a;
				e.forEach((e, a) => {
					var c;
					let l = (c = o) == null || (c = c.get(a)) == null ? void 0 : c.s;
					if (l) e.s = l;
					else {
						let o = {
							s: a,
							d: n,
							k: t,
							c: s,
							n: r,
							i
						};
						ht(o), e.s = o;
					}
				}), (a = o) == null || a.forEach((t, n) => {
					!e.has(n) && t.s && gt(t.s);
				}), o = e;
			};
			c instanceof Promise ? c.finally(l) : l(), n[t] = c;
		};
		s();
	}), n;
}
//#endregion
//#region ../../../node_modules/valtio/esm/vanilla/utils.mjs
var vt = Symbol();
function yt(e, t) {
	typeof t == "string" && (console.warn("string name option is deprecated, use { name }. https://github.com/pmndrs/valtio/pull/400"), t = { name: t });
	let { enabled: n, name: r = "", ...i } = t || {}, a;
	try {
		a = (n ?? !1) && window.__REDUX_DEVTOOLS_EXTENSION__;
	} catch {}
	if (!a) return;
	let o = !1, s = a.connect({
		name: r,
		...i
	}), c = R(e, (t) => {
		let n = t.filter(([e, t]) => t[0] !== vt).map(([e, t]) => `${e}:${t.map(String).join(".")}`).join(", ");
		if (n) if (o) o = !1;
		else {
			let t = Object.assign({}, z(e));
			delete t[vt], s.send({
				type: n,
				updatedAt: (/* @__PURE__ */ new Date()).toLocaleString()
			}, t);
		}
	}), l = s.subscribe((t) => {
		if (t.type === "ACTION" && t.payload) try {
			Object.assign(e, JSON.parse(t.payload));
		} catch (e) {
			console.error("please dispatch a serializable value that JSON.parse() and proxy() support\n", e);
		}
		if (t.type === "DISPATCH" && t.state) {
			if (t.payload?.type === "JUMP_TO_ACTION" || t.payload?.type === "JUMP_TO_STATE") {
				o = !0;
				let n = JSON.parse(t.state);
				Object.assign(e, n);
			}
			e[vt] = t;
		} else if (t.type === "DISPATCH" && t.payload?.type === "COMMIT") s.init(z(e));
		else if (t.type === "DISPATCH" && t.payload?.type === "IMPORT_STATE") {
			let n = t.payload.nextLiftedState?.actionsById, r = t.payload.nextLiftedState?.computedStates || [];
			o = !0, r.forEach(({ state: t }, r) => {
				let i = n[r] || "No action found";
				Object.assign(e, t), r === 0 ? s.init(z(e)) : s.send(i, z(e));
			});
		}
	});
	return s.init(z(e)), () => {
		c(), l?.();
	};
}
function bt(e) {
	let t = L({
		data: Array.from(new Set(e)),
		has(e) {
			return this.data.indexOf(e) !== -1;
		},
		add(e) {
			let t = !1;
			return typeof e == "object" && e && (t = this.data.indexOf(L(e)) !== -1), this.data.indexOf(e) === -1 && !t && this.data.push(e), this;
		},
		delete(e) {
			let t = this.data.indexOf(e);
			return t === -1 ? !1 : (this.data.splice(t, 1), !0);
		},
		clear() {
			this.data.splice(0);
		},
		get size() {
			return this.data.length;
		},
		forEach(e) {
			this.data.forEach((t) => {
				e(t, t, this);
			});
		},
		get [Symbol.toStringTag]() {
			return "Set";
		},
		toJSON() {
			return new Set(this.data);
		},
		[Symbol.iterator]() {
			return this.data[Symbol.iterator]();
		},
		values() {
			return this.data.values();
		},
		keys() {
			return this.data.values();
		},
		entries() {
			return new Set(this.data).entries();
		}
	});
	return Object.defineProperties(t, {
		data: { enumerable: !1 },
		size: { enumerable: !1 },
		toJSON: { enumerable: !1 }
	}), Object.seal(t), t;
}
//#endregion
//#region src/conversationStore.ts
var xt = {
	articleId: null,
	articleCollectionId: null,
	unableToFindTaggedSuggestions: !1,
	searchTerm: ""
}, W = L({
	currentConversationId: 0,
	suggestionState: {},
	currentQueueId: ""
}), St = _t({ current: (e) => {
	let t = e(W).currentConversationId;
	return t && e(W).suggestionState[t] || xt;
} }, { proxy: W }), Ct = {
	setConversationId: (e) => {
		W.currentConversationId = e, W.suggestionState[e] || (W.suggestionState[e] = xt);
	},
	setCurrentArticle: (e) => {
		W.suggestionState[e.conversationId].articleCollectionId = e.articleCollectionId, W.suggestionState[e.conversationId].articleId = e.articleId;
	},
	clearCurrentArticle: () => {
		W.suggestionState[W.currentConversationId] && (W.suggestionState[W.currentConversationId].articleCollectionId = null, W.suggestionState[W.currentConversationId].articleId = null);
	},
	setSearchTermForCurrentConversation: (e) => {
		W.suggestionState[W.currentConversationId].searchTerm = e;
	},
	setQueueId: (e) => {
		W.currentQueueId = e;
	}
};
yt(W, {
	name: "suggestionStore",
	enabled: process.env.NODE_ENV === "development"
});
//#endregion
//#region ../management-common/src/apolloClient.ts
var wt = "beta";
function Tt() {
	return r({ uri: `${d.url.knowledgeApi}/management/api/${wt}/graphql` });
}
var Et = new n({ typePolicies: {
	Article: { fields: { tags: { merge(e, t) {
		return t;
	} } } },
	Collection: { merge: !0 },
	ArticleTranslation: { keyFields: [
		"articleId",
		"languageId",
		"version",
		["__typename"]
	] },
	ArticleList: { keyFields: ["query", ["results"]] },
	ArticleListItem: { fields: { titles: { merge(e, t) {
		return t;
	} } } },
	Query: { fields: {
		category: { read(e, { args: t, toReference: n }) {
			if (t?.id) return n({
				__typename: "Category",
				id: t.id
			});
		} },
		article: { read(e, { args: t, toReference: n }) {
			if (t?.id) return n({
				__typename: "Article",
				id: t.id
			});
		} },
		aiDraft: { read(e, { args: t, toReference: n }) {
			if (t?.id) return n({
				__typename: "AiDraft",
				id: t.id
			});
		} },
		articles: { keyArgs: ["$filters", "$query"] },
		collections: {
			keyArgs: !1,
			merge(e, t, { args: n }) {
				return !e || !n?.offset ? t : {
					...t,
					results: [...e.results.slice(0, n.offset), ...t.results]
				};
			}
		}
	} }
} }), Dt;
function Ot() {
	return Dt ||= new t({
		link: i([
			s({
				sha256: pe,
				useGETForHashedQueries: !1
			}),
			ve(),
			Tt()
		].filter(Boolean)),
		cache: Et,
		assumeImmutableResults: !0,
		defaultOptions: { query: { canonizeResults: !0 } },
		connectToDevTools: !0
	}), Dt;
}
//#endregion
//#region ../management-common/src/graphql.ts
var G = {}, kt = /* @__PURE__ */ function(e) {
	return e.Ar = "ar", e.Bg = "bg", e.Ca = "ca", e.CaValencia = "ca_valencia", e.Cs = "cs", e.Da = "da", e.De = "de", e.DeAt = "de_at", e.DeBe = "de_be", e.DeCh = "de_ch", e.Ee = "ee", e.El = "el", e.En = "en", e.EnAu = "en_au", e.EnCa = "en_ca", e.EnGb = "en_gb", e.EnIe = "en_ie", e.EnNz = "en_nz", e.EnUs = "en_us", e.Es = "es", e.Es_419 = "es_419", e.Et = "et", e.Eu = "eu", e.Fa = "fa", e.Fi = "fi", e.Fr = "fr", e.FrBe = "fr_be", e.FrCa = "fr_ca", e.FrCh = "fr_ch", e.Gl = "gl", e.Hi = "hi", e.Hr = "hr", e.Hu = "hu", e.Id = "id", e.Is = "is", e.It = "it", e.ItCh = "it_ch", e.Iw = "iw", e.Ja = "ja", e.Ko = "ko", e.Lt = "lt", e.Lv = "lv", e.Nb = "nb", e.Nl = "nl", e.NlBe = "nl_be", e.Nn = "nn", e.No = "no", e.Pl = "pl", e.Pt = "pt", e.PtBr = "pt_br", e.Ro = "ro", e.Ru = "ru", e.Sk = "sk", e.Sl = "sl", e.Sq = "sq", e.Sr = "sr", e.Sv = "sv", e.Th = "th", e.Tr = "tr", e.Uk = "uk", e.Vi = "vi", e.Zh = "zh", e.ZhHant = "zh_hant", e;
}({}), K = a`
  fragment AiDraftListItem on AiDraft {
    __typename
    id
    title
    type
    languageId
    createdAt
    modifiedAt
    initiatedFromConversation
    referencedConversationIds
    collectionId
    categoryId
    possibleCollectionIds
    forArticleId
    initiatedBy {
      id
      name
      email
      avatarUrl
    }
    summary
    htmlContent
  }
`;
a`
  fragment ArticleNode on Article {
    id
    parent {
      id
    }
    titles {
      title
      languageId
    }
  }
`, a`
  fragment ArticleListItemNode on ArticleListItem {
    id
    parentCategories {
      id
    }
    titles {
      title
      languageId
    }
  }
`;
var At = a`
  fragment ArticleListItemResult on ArticleListItem {
    __typename
    id
    isSyncedWithElevio: isLocked
    title(languageId: $languageId)
    titles {
      languageId
      title
    }
    publicationStatus(languageId: $languageId)
    parentCollections {
      id
      internalKbEnabled
      title
      linkedResources {
        id
        name
        ... on Queue {
          id
          name
        }
      }
    }
    createdAt
    updatedAt
    createdBy {
      name
      deactivated
    }
    updatedBy {
      name
      deactivated
    }
    parentCategories {
      id
      title(languageId: $languageId)
      parentCollections {
        id
        title
      }
    }
  }
`, q = a`
  fragment CategoryFields on Category {
    id
    parent {
      id
    }
    titles {
      title
      languageId
    }
    restrictions {
      direct
      inherited {
        restriction
        from {
          id
        }
      }
    }
    isSyncedWithElevio: isLocked
  }
`, J = a`
  fragment ArticleFields on Article {
    id
    isSyncedWithElevio: isLocked
    updatedAt
    indexedAt
    parent {
      id
    }
    titles {
      title
      languageId
    }
    restrictions {
      direct
      inherited {
        restriction
        from {
          id
        }
      }
    }
  }
`, jt = a`
  fragment CategoryChild on Category {
    ...CategoryFields
    articles {
      ...ArticleFields
    }
    categories {
      ...CategoryFields
    }
  }
  ${q}
  ${J}
`;
a`
  fragment CategoryNode on Category {
    id
    parent {
      id
    }
    restrictions {
      direct
    }
  }
`;
var Y = a`
  fragment CollectionFields on Collection {
    id
    title
    internalKbEnabled
    isSyncedWithElevio: isLocked
    description
    themeColors {
      icon
    }
    linkedResources {
      id
      name
      ... on Queue {
        id
        name
      }
    }
  }
`, X = a`
  fragment ManagementOrganizationSettings on OrganisationSettingsPayload {
    availableLanguages {
      ...LanguageFields
    }
    defaultLanguage {
      ...LanguageFields
    }
    enabledLanguages {
      ...LanguageFields
    }
  }
  ${a`
  fragment LanguageFields on Language {
    languageId
    description
    nativeDescription
  }
`}
`, Mt = a`
  fragment SettingsFields on SettingsPayload {
    isOrganisationSetup
    canCreateCollections
  }
`, Z = a`
  fragment ArticleFullFields on Article {
    id
    aiAssisted
    createdAt
    createdBy {
      name
      email
    }
    updatedAt
    updatedBy {
      name
      email
    }
    indexedAt
    indexedBy {
      name
      email
    }
    parent {
      id
      ... on Category {
        titles {
          title
          languageId
        }
      }
    }
    tags {
      id
      name
      color
      type
      isDeactivated
    }
    isSyncedWithElevio: isLocked
    titles {
      title
      languageId
    }
    translations {
      draft {
        languageId
        articleId
        title
        publicationStatus
        version {
          __typename
        }
      }
    }
    parentCollections {
      id
      title
    }
  }
`, Q = a`
  fragment ArticleTranslationFields on ArticleTranslation {
    articleId
    languageId
    version {
      __typename
    }
    title
    aiAssisted
    titleTranslatedAt
    titleUpdatedAt
    content
    updatedAt
    updatedBy {
      name
      email
    }
    publicationStatus
  }
`, Nt = a`
  fragment HelpCenterCustomHostname on HelpCenter {
    id
    customHostname {
      hostname
      records {
        cname {
          record {
            aliasOf
            hostname
          }
          status
          verificationErrors
        }
        ssl {
          records {
            name
            value
          }
          status
        }
      }
    }
  }
`, $ = a`
  fragment HelpCenter on HelpCenter {
    id
    name
    subdomain
    hostname
    isHelpCenterIndexable
    collection {
      id
    }
    isActive
    favicon {
      availableAt
    }
    logo {
      filename
      fileType
      availableAt
      size
      uploadedAt
      originalFileName
    }
    companyUrl
    favicon {
      filename
      fileType
      availableAt
      size
      uploadedAt
      originalFileName
    }
    translations {
      languageId
      title
      tagline
    }
    theme {
      id
      colors {
        websiteBackground
        pageBackground
        text
        link
        accent
        accentText
      }
    }
    themeCustomization {
      headerHtml {
        value
        enabled
      }
      footerHtml {
        value
        enabled
      }
      css {
        value
        enabled
      }
      js {
        value
        enabled
      }
    }
    enabledLanguages {
      languageId
    }
    defaultLanguage {
      languageId
      description
    }
  }
`;
a`
  fragment CategoryTitles on Category {
    id
    titles {
      title
      languageId
    }
  }
`, a`
  mutation AiDraftApprove($id: ID!, $alsoPublish: Boolean!) {
    aiDraftApprove(id: $id, alsoPublish: $alsoPublish) {
      id
    }
  }
`, a`
  query AiDraft($id: ID!) {
    aiDraft(id: $id) {
      ...AiDraftListItem
    }
  }
  ${K}
`, a`
  mutation AiDraftReject($id: ID!) {
    aiDraftReject(id: $id) {
      id
    }
  }
`;
var Pt = a`
  mutation AiDraftUpdate(
    $id: ID!
    $feedback: NonEmptyString
    $collectionId: ID
    $categoryId: ID
  ) {
    aiDraftUpdate(
      id: $id
      feedback: $feedback
      collectionId: $collectionId
      categoryId: $categoryId
    ) {
      ...AiDraftListItem
    }
  }
  ${K}
`;
function Ft(t) {
	let n = {
		...G,
		...t
	};
	return e.useMutation(Pt, n);
}
a`
  query AiDrafts(
    $searchQuery: NonEmptyString
    $filters: AiDraftFiltersInput
    $limit: Limit
    $offset: Offset
  ) {
    aiDrafts(
      searchQuery: $searchQuery
      filters: $filters
      limit: $limit
      offset: $offset
    ) {
      results {
        ...AiDraftListItem
      }
      pagination {
        hasMore
        end
        total
      }
    }
  }
  ${K}
`;
var It = a`
  mutation ArticleCreate(
    $translations: [ArticleTranslationInput!]!
    $parentId: ID!
  ) {
    articleCreate(translations: $translations, parentId: $parentId) {
      ...ArticleFields
    }
  }
  ${J}
`;
function Lt(t) {
	let n = {
		...G,
		...t
	};
	return e.useMutation(It, n);
}
a`
  mutation ArticleDelete($id: ID!) {
    articleDelete(id: $id)
  }
`, a`
  mutation ArticleMove(
    $entityId: ID!
    $currentParentId: ID!
    $newParentId: ID
    $newPosition: PositiveInt
  ) {
    contentMove(
      entityId: $entityId
      currentParentId: $currentParentId
      newParentId: $newParentId
      newPosition: $newPosition
    ) {
      id
    }
  }
`, a`
  mutation ArticleTranslationUpdate(
    $articleId: ID!
    $languageId: LanguageId!
    $title: NonEmptyString
    $content: ContentJson
    $titleUpdatedAt: String
    $titleTranslatedAt: String
  ) {
    articleTranslationUpdate(
      articleId: $articleId
      languageId: $languageId
      title: $title
      content: $content
      titleUpdatedAt: $titleUpdatedAt
      titleTranslatedAt: $titleTranslatedAt
    ) {
      ...ArticleTranslationFields
    }
  }
  ${Q}
`, a`
  mutation ArticleDetachFromElevio($id: ID!) {
    articleUnlock(id: $id) {
      id
      isSyncedWithElevio: isLocked
    }
  }
`, a`
  query Articles(
    $languageId: LanguageId!
    $limit: Limit
    $offset: Offset
    $filters: ArticleFiltersInput
    $query: ArticleSearchInput
  ) {
    articles(limit: $limit, offset: $offset) {
      query(query: $query, filters: $filters) {
        results {
          ...ArticleListItemResult
        }
        pagination {
          hasMore
          end
        }
      }
    }
  }
  ${At}
`, a`
  mutation CategoryCreate(
    $parentId: ID!
    $translations: [CategoryTranslationInputInput!]!
  ) {
    categoryCreate(parentId: $parentId, translations: $translations) {
      ...CategoryFields
    }
  }
  ${q}
`, a`
  mutation CategoryDelete($categoryId: ID!) {
    categoryDelete(id: $categoryId)
  }
`;
var Rt = a`
  query CategoryDropdown($collectionId: ID!) {
    collection(id: $collectionId) {
      categories {
        id
        isSyncedWithElevio: isLocked
        titles {
          title
          languageId
        }
        categories {
          id
          isSyncedWithElevio: isLocked
          titles {
            title
            languageId
          }
          categories {
            id
            isSyncedWithElevio: isLocked
            titles {
              title
              languageId
            }
            categories {
              id
              isSyncedWithElevio: isLocked
              titles {
                title
                languageId
              }
              categories {
                id
                isSyncedWithElevio: isLocked
                titles {
                  title
                  languageId
                }
              }
            }
          }
        }
      }
    }
  }
`;
function zt(t) {
	let n = {
		...G,
		...t
	};
	return e.useQuery(Rt, n);
}
a`
  mutation CategoryMove(
    $entityId: ID!
    $currentParentId: ID!
    $newParentId: ID
    $newPosition: PositiveInt
  ) {
    contentMove(
      entityId: $entityId
      currentParentId: $currentParentId
      newParentId: $newParentId
      newPosition: $newPosition
    ) {
      id
      categories {
        id
        parent {
          id
        }
      }
    }
  }
`, a`
  query CategoryMoveQ($id: ID!) {
    category(id: $id) {
      id
      parent {
        id
      }
    }
  }
`, a`
  query CategoryNode($id: ID!) {
    category(id: $id) {
      ...CategoryChild
    }
  }
  ${jt}
`, a`
  query Category($id: ID!) {
    category(id: $id) {
      id
      titles {
        languageId
        title
      }
      parent {
        id
      }
      restrictions {
        direct
      }
      isSyncedWithElevio: isLocked
    }
  }
`, a`
  mutation CategoryTranslationDelete($id: ID!, $languageId: LanguageId!) {
    categoryTranslationDelete(id: $id, languageId: $languageId) {
      ...CategoryFields
    }
  }
  ${q}
`, a`
  mutation CategoryTranslationUpsert(
    $id: ID!
    $languageId: LanguageId!
    $title: NonEmptyString!
  ) {
    categoryTranslationUpsert(id: $id, languageId: $languageId, title: $title) {
      ...CategoryFields
    }
  }
  ${q}
`, a`
  mutation CategoryUpdate($id: ID!) {
    categoryUpdate(id: $id) {
      ...CategoryFields
    }
  }
  ${q}
`, a`
  mutation CollectionCreate(
    $title: NonEmptyString!
    $internalKbEnabled: Boolean!
  ) {
    collectionCreate(title: $title, internalKbEnabled: $internalKbEnabled) {
      ...CollectionFields
    }
  }
  ${Y}
`, a`
  mutation CollectionDelete($id: ID!) {
    collectionDelete(id: $id)
  }
`, a`
  mutation CollectionDetach($id: ID!) {
    collectionUnlock(id: $id) {
      ...CollectionFields
    }
  }
  ${Y}
`, a`
  query Collection($id: ID!) {
    collection(id: $id) {
      ...CollectionFields
    }
  }
  ${Y}
`, a`
  query CollectionStats($id: ID!) {
    collection(id: $id) {
      id
      statistics {
        categoryCount
        articleCount
        queueCount
      }
    }
  }
`, a`
  query CollectionTree($id: ID!) {
    collection(id: $id) {
      ...CollectionFields
      categories {
        ...CategoryFields
        articles {
          ...ArticleFields
        }
        categories {
          ...CategoryFields
          articles {
            ...ArticleFields
          }
          categories {
            ...CategoryFields
            articles {
              ...ArticleFields
            }
            categories {
              ...CategoryFields
              articles {
                ...ArticleFields
              }
              categories {
                ...CategoryFields
                articles {
                  ...ArticleFields
                }
              }
            }
          }
        }
      }
    }
  }
  ${Y}
  ${q}
  ${J}
`, a`
  mutation CollectionUpdate(
    $id: ID!
    $title: NonEmptyString
    $externalResources: ResourcesUpdateInput
    $internalKbEnabled: Boolean!
    $icon: Color!
    $description: String
  ) {
    collectionUpdate(
      id: $id
      title: $title
      externalResources: $externalResources
      internalKbEnabled: $internalKbEnabled
      themeColors: { icon: $icon }
      description: $description
    ) {
      ...CollectionFields
    }
  }
  ${Y}
`, a`
  query CollectionsFetch($offset: Offset, $limit: Limit) {
    collections(offset: $offset, limit: $limit) {
      results {
        id
        title
        internalKbEnabled
        isSyncedWithElevio: isLocked
      }
    }
    settings {
      ...SettingsFields
    }
  }
  ${Mt}
`, a`
  mutation FileUpload($fileName: NonEmptyString!) {
    fileUploadRequest(filename: $fileName) {
      uploadUrl
      method
      contentType
      customHeaders
      expiresAt
      filename
      availableAt
    }
  }
`, a`
  query OptimisticArticleParent($id: ID!) {
    category(id: $id) {
      id
      articles {
        id
      }
    }
  }
`, a`
  query OptimisticCategory($id: ID!) {
    category(id: $id) {
      id
      categories {
        id
        parent {
          id
        }
      }
    }
  }
`, a`
  query OptimisticCollection($id: ID!) {
    collection(id: $id) {
      id
      categories {
        id
        parent {
          id
        }
      }
    }
  }
`, a`
  mutation OrganizationEnableLanguages($languageIds: [LanguageId!]!) {
    organisationEnableLanguages(languageIds: $languageIds) {
      ...ManagementOrganizationSettings
    }
  }
  ${X}
`, a`
  mutation OrganizationRemoveLanguage($languageId: LanguageId!) {
    organisationDisableLanguage(languageId: $languageId) {
      ...ManagementOrganizationSettings
    }
  }
  ${X}
`, a`
  mutation OrganizationSetDefaultLanguage($languageId: LanguageId!) {
    organisationSetDefaultLanguage(languageId: $languageId) {
      ...ManagementOrganizationSettings
    }
  }
  ${X}
`, a`
  query OrganizationSettings {
    organisationSettings {
      ...ManagementOrganizationSettings
    }
  }
  ${X}
`, a`
  query Owners {
    articles {
      owners {
        id
        name
        fullName {
          givenName
          middleNames
          familyName
        }
        avatarUrl
      }
    }
  }
`, a`
  mutation ParentAddChild($childId: ID!, $parentId: ID!) {
    parentAddChild(childId: $childId, parentId: $parentId) {
      id
    }
  }
`, a`
  query Settings {
    settings {
      ...SettingsFields
    }
  }
  ${Mt}
`, a`
  mutation SetupOrganisation {
    setupOrganisation {
      id
      title
    }
  }
`;
var Bt = a`
  query AiDraftByCsid($csid: Long!) {
    aiDraftByCsid(csid: $csid) {
      ...AiDraftListItem
    }
  }
  ${K}
`;
function Vt(t) {
	let n = {
		...G,
		...t
	};
	return e.useQuery(Bt, n);
}
var Ht = a`
  mutation AiDraftDelete($id: ID!) {
    aiDraftDelete(id: $id)
  }
`;
function Ut(t) {
	let n = {
		...G,
		...t
	};
	return e.useMutation(Ht, n);
}
var Wt = a`
  mutation AiDraftGenerate(
    $csid: Long!
    $languageId: LanguageId!
    $collectionId: ID
    $categoryId: ID
  ) {
    aiDraftGenerate(
      csid: $csid
      languageId: $languageId
      collectionId: $collectionId
      categoryId: $categoryId
    ) {
      ...AiDraftListItem
    }
  }
  ${K}
`;
function Gt(t) {
	let n = {
		...G,
		...t
	};
	return e.useMutation(Wt, n);
}
a`
  query AiDraftLiveUpdate($id: ID!) {
    aiDraft(id: $id) {
      ...AiDraftListItem
      approvedAt
      rejectedAt
    }
  }
  ${K}
`, a`
  query ArticleEditor($id: ID!) {
    article(id: $id) {
      ...ArticleFullFields
    }
  }
  ${Z}
`, a`
  query ArticleHasChanges($articleId: ID!) {
    article(id: $articleId) {
      id
      translations {
        draft {
          articleId
          languageId
          publicationStatus
        }
      }
    }
  }
`, a`
  query ArticleLinkLookup(
    $languageId: LanguageId!
    $filters: ArticleFiltersInput
    $query: ArticleSearchInput
  ) {
    articles(limit: 15, offset: 0) {
      query(query: $query, filters: $filters) {
        results {
          id
          title(languageId: $languageId)
          parentCategories {
            id
            title(languageId: $languageId)
          }
        }
      }
    }
  }
`, a`
  mutation ArticlePublish($articleId: ID!) {
    articlePublish(articleId: $articleId) {
      ...ArticleFullFields
    }
  }
  ${Z}
`, a`
  mutation ArticleTranslationDelete($articleId: ID!, $languageId: LanguageId!) {
    articleTranslationDelete(articleId: $articleId, languageId: $languageId)
  }
`, a`
  mutation ArticleTranslationDraftCreate(
    $articleId: ID!
    $languageId: LanguageId!
    $title: NonEmptyString!
    $content: ContentJson!
  ) {
    articleTranslationCreate(
      articleId: $articleId
      languageId: $languageId
      title: $title
      content: $content
    ) {
      ...ArticleTranslationFields
    }
  }
  ${Q}
`, a`
  mutation ArticleTranslationDraftUpdate(
    $articleId: ID!
    $languageId: LanguageId!
    $title: NonEmptyString!
    $content: ContentJson!
    $titleUpdatedAt: String
    $titleTranslatedAt: String
  ) {
    articleTranslationUpdate(
      articleId: $articleId
      languageId: $languageId
      title: $title
      content: $content
      titleUpdatedAt: $titleUpdatedAt
      titleTranslatedAt: $titleTranslatedAt
    ) {
      ...ArticleTranslationFields
    }
  }
  ${Q}
`, a`
  query ArticleTranslation($id: ID!, $languageId: LanguageId!) {
    articleTranslation(id: $id, languageId: $languageId) {
      articleId
      publicationStatus
      draft {
        ...ArticleTranslationFields
      }
    }
  }
  ${Q}
`, a`
  mutation ArticleTranslationPublish(
    $articleId: ID!
    $languageId: LanguageId!
  ) {
    articleTranslationPublish(articleId: $articleId, languageId: $languageId)
  }
`, a`
  mutation ArticleTranslationRevertDraft(
    $articleId: ID!
    $languageId: LanguageId!
    $version: PositiveInt
    $publish: Boolean
  ) {
    articleTranslationRevertDraft(
      articleId: $articleId
      languageId: $languageId
      version: $version
      publish: $publish
    ) {
      ...ArticleTranslationFields
    }
  }
  ${Q}
`, a`
  mutation ArticleTranslationUnpublish(
    $articleId: ID!
    $languageId: LanguageId!
  ) {
    articleTranslationUnpublish(articleId: $articleId, languageId: $languageId)
  }
`, a`
  query ArticleTranslationVersion(
    $articleId: ID!
    $languageId: LanguageId!
    $versionNumber: PositiveInt!
  ) {
    article(id: $articleId) {
      translation(languageId: $languageId) {
        version(versionNumber: $versionNumber) {
          articleId
          languageId
          version {
            __typename
          }
          title
          content
        }
      }
    }
  }
`, a`
  query ArticleTranslationVersions($articleId: ID!, $languageId: LanguageId!) {
    article(id: $articleId) {
      translations {
        versions(languageId: $languageId) {
          publishedAt
          publishedBy {
            name
          }
          title
          version {
            __typename
            ... on Indexed {
              versionNumber
            }
          }
          isCurrentlyIndexed
          aiAssisted
          referencedConversationIds
        }
      }
    }
  }
`, a`
  mutation ArticleUnpublish($articleId: ID!) {
    articleUnpublish(articleId: $articleId) {
      ...ArticleFullFields
    }
  }
  ${Z}
`, a`
  mutation ArticleUpdate($articleId: ID!, $tags: TagsInput) {
    articleUpdate(id: $articleId, tags: $tags) {
      ...ArticleFullFields
    }
  }
  ${Z}
`, a`
  mutation HelpCenterAddCompanyLogo($id: ID!, $logo: String!) {
    helpCenterUpdate(id: $id, logo: $logo) {
      id
      logo {
        filename
        fileType
        availableAt
        size
        uploadedAt
        originalFileName
      }
    }
  }
`, a`
  mutation HelpCenterAddFavicon($id: ID!, $favicon: String!) {
    helpCenterUpdate(id: $id, favicon: $favicon) {
      id
      favicon {
        filename
        fileType
        availableAt
        size
        uploadedAt
        originalFileName
      }
    }
  }
`, a`
  mutation HelpCenterCreate(
    $subdomain: String!
    $translations: [HelpCenterTranslationInput!]!
    $name: NonEmptyString!
    $collectionId: ID!
    $defaultLanguageId: LanguageId!
    $isHelpCenterIndexable: Boolean!
  ) {
    helpCenterCreate(
      subdomain: $subdomain
      translations: $translations
      name: $name
      collectionId: $collectionId
      defaultLanguage: $defaultLanguageId
      isHelpCenterIndexable: $isHelpCenterIndexable
    ) {
      id
      name
      translation(languageId: $defaultLanguageId) {
        languageId
        title
        tagline
      }
      subdomain
      hostname
      customHostname {
        hostname
      }
      isHelpCenterIndexable
      collection {
        id
        title
      }
      isActive
      favicon {
        filename
        fileType
        availableAt
      }
      logo {
        filename
        fileType
        availableAt
      }
    }
  }
`, a`
  query HelpCenterCustomHostnameFetch($id: ID!) {
    helpCenter(id: $id) {
      ...HelpCenterCustomHostname
    }
  }
  ${Nt}
`, a`
  mutation HelpCenterCustomizationDeleteFavicon($helpCenterId: ID!) {
    helpCenterUpdate(id: $helpCenterId, favicon: "") {
      favicon {
        availableAt
        filename
      }
    }
  }
`, a`
  mutation HelpCenterCustomizationDeleteLogo($helpCenterId: ID!) {
    helpCenterUpdate(id: $helpCenterId, logo: "") {
      logo {
        availableAt
        filename
      }
    }
  }
`, a`
  mutation HelpCenterDelete($id: ID!, $deregisterCustomHostname: Boolean) {
    helpCenterDelete(
      id: $id
      deregisterCustomHostname: $deregisterCustomHostname
    )
  }
`, a`
  mutation HelpCenterDeregisterHostname($id: ID!) {
    helpCenterDeregisterHostname(id: $id) {
      ...HelpCenterCustomHostname
    }
  }
  ${Nt}
`, a`
  query HelpCenterFetch($id: ID!) {
    helpCenter(id: $id) {
      ...HelpCenter
    }
  }
  ${$}
`, a`
  mutation HelpCenterRegisterHostname($id: ID!, $customHostname: String!) {
    helpCenterRegisterHostname(id: $id, customHostname: $customHostname) {
      ...HelpCenterCustomHostname
    }
  }
  ${Nt}
`, a`
  mutation HelpCenterUpdateAdvancedCustomization(
    $helpCenterId: ID!
    $themeCustomization: HelpCenterThemeCustomizationInput!
  ) {
    helpCenterUpdate(
      id: $helpCenterId
      themeCustomization: $themeCustomization
    ) {
      id
      themeCustomization {
        headerHtml {
          value
          enabled
        }
        footerHtml {
          value
          enabled
        }
        css {
          value
          enabled
        }
        js {
          value
          enabled
        }
      }
    }
  }
`, a`
  mutation HelpCenterUpdateCustomization(
    $helpCenterId: ID!
    $themeId: ID!
    $colors: HelpCenterThemeColorsUpdateInput!
    $companyUrl: URL!
  ) {
    helpCenterUpdate(id: $helpCenterId, companyUrl: $companyUrl) {
      ...HelpCenter
    }
    helpCenterThemeUpdate(id: $themeId, colors: $colors) {
      id
      name
      colors {
        websiteBackground
        pageBackground
        text
        link
        accent
        accentText
      }
    }
  }
  ${$}
`, a`
  mutation HelpCenterUpdateCustomizationTranslations(
    $helpCenterId: ID!
    $translation: HelpCenterTranslationInput!
  ) {
    helpCenterUpdate(id: $helpCenterId, translation: $translation) {
      ...HelpCenter
    }
  }
  ${$}
`, a`
  mutation HelpCenterUpdateSettings(
    $id: ID!
    $subdomain: String
    $collectionId: ID
    $active: Boolean!
    $name: NonEmptyString!
    $isHelpCenterIndexable: Boolean!
    $enableLanguages: [LanguageId!]
    $disableLanguages: [LanguageId!]
    $defaultLanguage: LanguageId
  ) {
    helpCenterUpdate(
      id: $id
      subdomain: $subdomain
      collectionId: $collectionId
      active: $active
      name: $name
      isHelpCenterIndexable: $isHelpCenterIndexable
      enableLanguages: $enableLanguages
      disableLanguages: $disableLanguages
      defaultLanguage: $defaultLanguage
    ) {
      ...HelpCenter
    }
  }
  ${$}
`, a`
  query HelpCenters {
    helpCenters(offset: 0, limit: 50) {
      results {
        id
        name
        hostname
        customHostname {
          hostname
        }
        isActive
        collection {
          id
          title
        }
      }
    }
  }
`, a`
  query SubdomainAvailability($subdomain: String!) {
    subdomainAvailability(subdomain: $subdomain) {
      isAvailable
      reason
    }
  }
`;
//#endregion
//#region src/hooks/useCollections/index.ts
function Kt() {
	return Ne();
}
//#endregion
export { Se as A, ge as B, Xe as C, ye as D, ke as E, Le as F, x as H, ze as I, Ge as L, je as M, Ue as N, be as O, Fe as P, ve as R, Ze as S, Je as T, de as U, pe as V, L as _, Ut as a, N as b, Lt as c, Ct as d, St as f, B as g, pt as h, Vt as i, Ve as j, xe as k, zt as l, bt as m, Bt as n, Gt as o, W as p, kt as r, Ft as s, Kt as t, Ot as u, R as v, qe as w, it as x, M as y, _e as z };

//# sourceMappingURL=useCollections-BPbWcv6t.js.map